<template>
  <ul class="subMenu" v-if="submenu.length > 0 && this.$route.matched[2].meta.leaf">
      <li class="subMenuTitle">{{$route.matched[2].meta.title}}</li>
      <router-link tag="li" :to="item.path" v-for="(item, i) in submenu" :class="$route.matched[3] && item.path == $route.matched[3].path ? 'router-link-active' : ''" :key="i">{{item.meta.title}}</router-link>
  </ul>
</template>

<script>
  export default {
    name: 'subMenu',
    data() {
      return {

      }
    },
    computed:{
      submenu(){
        let menu = []
        let currenMenuMatched = this.$route.matched
        this.$store.state.permission.addRoutes.map((item) => {
          if(item.name == 'layout'){
            item.children.map( subItem => {
              if(subItem.path == currenMenuMatched[1].path){
                subItem.children.map( subSubItem => {
                  if(subSubItem.path == currenMenuMatched[2].path){
                    menu = subSubItem.children
                  }
                })
              }
            })
          }
        })
        return menu
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
.subMenu{
  background-color: #fff;
  margin: 0;
  padding: 21px 0;
  width: 125px;
  font-size: 12px;
  color: #666;
  line-height: 32px;
  /*height: 100%;*/
  li{
    padding: 0 21px;
    cursor: pointer;
    &.router-link-active{
      background-color: #428efe;
      color: #fff;
    }
    &.subMenuTitle{
      color: #333;
      font-weight: bold;
      cursor: inherit;
    }

  }
}
</style>
